/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseAuditUpdate } from '../../models/response-audit-update';

export interface GetAuditUpdates$Params {
  customerBaseId: number;
  fieldname?: string;
  oldValue?: string;
  newValue?: string;
  lastModifiedDate?: string;
  lastModifiedBy?: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export function getAuditUpdates(http: HttpClient, rootUrl: string, params: GetAuditUpdates$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAuditUpdate>> {
  const rb = new RequestBuilder(rootUrl, getAuditUpdates.PATH, 'get');
  if (params) {
    rb.path('customerBaseId', params.customerBaseId, {});
    rb.query('fieldname', params.fieldname, {});
    rb.query('oldValue', params.oldValue, {});
    rb.query('newValue', params.newValue, {});
    rb.query('lastModifiedDate', params.lastModifiedDate, {});
    rb.query('lastModifiedBy', params.lastModifiedBy, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseAuditUpdate>;
    })
  );
}

getAuditUpdates.PATH = '/auditing/{customerBaseId}/updates';
